<!-- Need to add Loader when data is still in loading state, which can be go to the else -->
<div class="row" *ngIf="standardEarnings$ | async as standardEarnings">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div *ngIf="standardEarnings$ | async as standardEarnings" class="border-bottom">
          <p>
            These are Standard earnings which are available when you add salaries of your employees.
          </p>
        </div>
        <div class="content">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody *ngIf="standardEarnings$ | async as standardEarnings">
              <tr *ngFor="let item of standardEarnings; let i = index">
                <td>{{ item.name }}</td>
                <td style="word-wrap: break-word; white-space: normal">{{ item.description }}</td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      (click)="openEditModal(addEarningModal, item)"
                      *appHasPermission="{ standardEarnings: ['edit'] }"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      (click)="openDeleteModal(deleteModal, item)"
                      *appHasPermission="{ standardEarnings: ['delete'] }"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 theiaStickySidebar" *appHasPermission="{ standardEarnings: ['add'] }">
    <div class="card">
      <div class="card-body">
        <!-- <div class="d-flex flex-column list-group settings-list"> -->
        <div class="d-grid">
          <button (click)="openModel(addEarningModal)" class="btn btn-primary" type="button">
            + New Earning
          </button>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>

<!-- models -->

<!-- Add Earning Modal -->
<ng-template #addEarningModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Earning</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
        </li>
        <!-- <li class="nav-item" role="presentation" [class.active]="currentStep === 2" (click)="stepChange(2)" >
            <span class="nav-link" [class.active]="currentStep === 2"  >Address</span>
          </li> -->
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <span class="nav-link" [class.active]="currentStep === 2">Advanced</span>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="form">
        <!-- Step 1 (Basic Info) -->
        <div *ngIf="currentStep === 1" id="first-field">
          <div class="row earning-row">
            <div>
              <label for="name" class="form-label"
                >Earning Name <span class="text-danger">*</span></label
              >
              <input
                appTrimInput
                id="name"
                type="text"
                class="form-control"
                formControlName="name"
              />
              <div *ngIf="form.get('name')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('name') }}
                </span>
              </div>
            </div>
            <div>
              <label for="description" class="form-label">Description</label>
              <textarea
                id="description"
                class="form-control"
                formControlName="description"
                maxlength="255"
              ></textarea>
            </div>
          </div>
          <div class="my-4" formGroupName="info">
            <label for="claculationType" class="form-label">Calculation Type</label>
            <div class="form-check">
              <input
                appTrimInput
                class="form-check-input"
                type="radio"
                id="flatAmount"
                value="flatAmount"
                formControlName="calculationType"
              />
              <label class="form-check-label" for="flatAmount"> Flat Amount </label>
            </div>
            <div class="form-check">
              <input
                appTrimInput
                class="form-check-input"
                type="radio"
                id="percentageOfBasic"
                value="percentageOfBasic"
                formControlName="calculationType"
              />
              <label class="form-check-label" for="percentageOfBasic"> Percentage of Basic </label>
            </div>
            <div class="form-check">
              <input
                appTrimInput
                class="form-check-input"
                type="radio"
                id="percentageOfCTC"
                value="percentageOfCTC"
                formControlName="calculationType"
              />
              <label class="form-check-label" for="percentageOfCTC"> Percentage of CTC </label>
            </div>
          </div>
          <div class="col-lg-12 text-end form-wizard-button">
            <button
              type="button"
              (click)="goToNextStep()"
              [disabled]="form.get('name')?.invalid"
              class="btn btn-primary wizard-next-btn"
            >
              Save & Next
            </button>
          </div>
        </div>
        <!-- Step 2 (Advanced) -->
        <div *ngIf="currentStep === 2">
          <div class="row" formGroupName="info">
            <div class="my-4">
              <label for="taxDeductionPreference" class="form-label"
                >Tax deduction preference</label
              >
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="subsequentPayrolls"
                  value="subsequentPayrolls"
                  formControlName="taxDeductionPreference"
                />
                <label class="form-check-label" for="subsequentPayrolls">
                  Deduct tax in subsequent payrolls of the financial year
                </label>
              </div>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="samePayroll"
                  value="samePayroll"
                  formControlName="taxDeductionPreference"
                />
                <label class="form-check-label" for="samePayroll">
                  Deduct tax in the same payroll
                </label>
              </div>
            </div>
            <div class="my-4">
              <div class="form-check form-switch">
                <label class="form-check-label" for="taxable">Taxable</label>
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="taxable"
                  formControlName="taxable"
                />
              </div>
            </div>
            <div class="col-lg-12 text-end form-wizard-button">
              <button
                type="submit"
                (click)="sendDataToParent()"
                class="btn btn-primary wizard-next-btn"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<!-- /Add Termination -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the entry, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="sendDataToParent()"
        >Yes, Delete</a
      >
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->
